import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { filter, map } from 'rxjs';

import { UserMenuComponent } from './shared/controls/user-menu/user-menu.component';

// No app chrome (nav/footer) on routes that must render standalone, e.g. the no-access page.
const NO_CHROME_ROUTES = ['/login', '/unauthorized'];

function stripQueryAndFragment(url: string): string {
  return url.split(/[?#]/)[0];
}

@Component({
  imports: [RouterOutlet, TranslocoPipe, UserMenuComponent],
  selector: 'app-root',
  styleUrl: './app.component.css',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => stripQueryAndFragment(event.urlAfterRedirects)),
    ),
    { initialValue: stripQueryAndFragment(this.router.url) },
  );

  protected readonly showChrome = computed(() => !NO_CHROME_ROUTES.includes(this.currentUrl()));
}
